__turbopack_context__.v({
  "modal-fade": "modal-module-scss-module__YWNhMq__modal-fade",
  "modal-zoom": "modal-module-scss-module__YWNhMq__modal-zoom",
  "modal_aria": "modal-module-scss-module__YWNhMq__modal_aria",
  "modal_closeButton": "modal-module-scss-module__YWNhMq__modal_closeButton",
  "modal_closeIcon": "modal-module-scss-module__YWNhMq__modal_closeIcon",
  "modal_content": "modal-module-scss-module__YWNhMq__modal_content",
  "modal_content__fullSize": "modal-module-scss-module__YWNhMq__modal_content__fullSize",
  "modal_dialog": "modal-module-scss-module__YWNhMq__modal_dialog",
  "modal_overlay": "modal-module-scss-module__YWNhMq__modal_overlay",
  "modal_overlay__positionMobileTop": "modal-module-scss-module__YWNhMq__modal_overlay__positionMobileTop",
});
